<div class="modal-header">
  <h4 class="modal-title">
    {{ 'upgrade_device' | translate }}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
</div>

<div class="modal-body pt-0">
  <div class="row mb-3">
    <div class="col">
      <span class="fw-light">
        {{ 'keep_old_plans_and_features' | translate }}
      </span>
    </div>
  </div>

  <form [formGroup]="upgrade_form">
    <div class="form-check" *ngFor="let item of device_upgrade_options; let i = index">
      <input
        type="radio"
        id="{{ item.name }}-{{ i }}"
        class="form-check-input"
        formControlName="upgradeOptions"
        [value]="item.id"
        [checked]="false"
      />
      <label class="form-check-label" for="{{ item.name }}-{{ i }}">{{ item.name }}</label>
    </div>
  </form>

  <div class="row mt-3">
    <div class="col d-flex justify-content-end">
      <button class="btn btn-outline-secondary me-2" type="button" (click)="dismissModal()">
        {{ 'cancel' | translate }}
      </button>
      <button
        class="btn btn-primary"
        type="button"
        [disabled]="this.upgrade_form.invalid"
        (click)="continueToUpgrade()"
      >
        {{ 'continue' | translate }}
      </button>
    </div>
  </div>
</div>
